import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { ICreateTourPayload } from '../screens/Tours/context/tours.interface';

export const getTours = (searchParams: any) => {
    const params = new URLSearchParams(searchParams);
    const url = `${OCTOPUS_BASE_URL}/tours`;
    const response = axios.get(url, { params });
    return response;
};

export const createTour = (payload: Partial<ICreateTourPayload>) => {
    const url = `${OCTOPUS_BASE_URL}/tours`;
    const response = axios.post(url, payload);
    return response;
};

export const updateTour = (tourId: string, payload: Partial<ICreateTourPayload>) => {
    const url = `${OCTOPUS_BASE_URL}/tours/${tourId}`;
    const response = axios.put(url, payload);
    return response;
};

export const deleteTour = (tourId: string) => {
    const url = `${OCTOPUS_BASE_URL}/tours/${tourId}`;
    const response = axios.delete(url);
    return response;
};
